module.exports = __webpack_public_path__ + "static/media/visitas.efd06768.png";